<template>
  <div class="p-6 bg-white rounded-lg">
    <div style="padding-top: 75%" class="relative">
      <div ref="powerbi" class="absolute pin"></div>
    </div>
  </div>
</template>

<script>
import * as pbi from 'powerbi-client'
export default {
  name: 'power-bi-report',
  props: {
    id: {
      type: String,
      required: true
    },
    embedUrl: {
      type: String,
      required: true
    },
    token: {
      type: String,
      required: true
    },
    filters: {
      type: Array,
      default () {
        return []
      }
    }
  },
  computed: {
    config () {
      return {
        type: 'report',
        id: this.id,
        embedUrl: this.embedUrl,
        accessToken: this.token,
        tokenType: pbi.models.TokenType.Embed,
        settings: {
          navContentPaneEnabled: false,
          filterPaneEnabled: false
        },
        filters: this.filters,
        background: pbi.models.BackgroundType.Transparent
      }
    }
  },
  mounted () {
    window.powerbi.embed(this.$refs.powerbi, this.config)
  }
}
</script>
